import React, { ComponentType } from 'react'
import { NavLink } from 'react-router-dom'

export interface UserVehicleLinkProps {
  internalUrl: string | null
}

export const UserVehicleLink = <P extends object>(
  WrappedComponent: ComponentType<P>
) => {
  return class UserVehicleLink extends React.Component<
    P & UserVehicleLinkProps
  > {
    render() {
      const { internalUrl } = this.props
      return (
        <div>
          {internalUrl && (
            <NavLink to={internalUrl}>
              <WrappedComponent {...this.props} />
            </NavLink>
          )}
          {!internalUrl && <WrappedComponent {...this.props} />}
        </div>
      )
    }
  }
}
